import { FiLinkToType } from '../fi-text-item-helper/fi-link-to-type';
import { ITextPanelMenuItem } from '../fi-text-panel/simple-text-panel/text-panel-base';

export const DocumentLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-file-lines',
    label: 'insert_link.document_link',
    value: FiLinkToType.Document,
};

export const MediaLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-file-image',
    label: 'insert_link.file_link',
    value: FiLinkToType.Media,
};

export const ColleagueLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-user',
    label: 'insert_link.colleague_link',
    value: FiLinkToType.UserProfile,
};

export const FormLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-clipboard-list',
    label: 'insert_link.form_link',
    value: FiLinkToType.Form,
};

export const ChecklistV2LinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-ballot-check',
    label: 'insert_link.checklist_v2_link',
    value: FiLinkToType.ChecklistV2,
};

export const ChecklistV2AuditLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-person-chalkboard',
    label: 'insert_link.checklist_v2_audit_link',
    value: FiLinkToType.ChecklistV2Audit,
};

export const ChecklistLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-check-square',
    label: 'insert_link.checklist_link',
    value: FiLinkToType.CheckList,
};

export const EmailLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-envelope',
    label: 'insert_link.email_address',
    value: FiLinkToType.Email,
};

export const PhoneNumberLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-phone',
    label: 'insert_link.phone_number',
    value: FiLinkToType.PhoneNumber,
};

export const WebAddressLinkMenuItem: ITextPanelMenuItem = {
    iconClass: 'far fa-globe-pointer',
    label: 'insert_link.web_link',
    value: FiLinkToType.WebAddress,
};
